import { render, staticRenderFns } from "./TenantsSlimList.vue?vue&type=template&id=94ade500&scoped=true&"
import script from "./TenantsSlimList.vue?vue&type=script&lang=js&"
export * from "./TenantsSlimList.vue?vue&type=script&lang=js&"
import style0 from "./TenantsSlimList.vue?vue&type=style&index=0&id=94ade500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ade500",
  null
  
)

export default component.exports